import {fabric} from "fabric";

export const canvasMix={
  data(){return{
    canvas: null,
    canvasWidth: 1700,
    canvasHeight: 800,
  }},
  methods:{
    // grid
    createLineGrid() {
      let groupLineGrid = new fabric.Group('', {
        objectCaching: false,
        hasControls: false,
        hasBorders: false,
        hasRotatingPoint: false,
        subTargetCheck: false,
        selectable: false
      })
      const gridsize = 20;
      for (let x = 1; x < (this.canvas.width / gridsize); x++) {

        groupLineGrid.addWithUpdate(new fabric.Line([gridsize * x, 0, gridsize * x, this.canvas.height], {
          stroke: "#DCEAEAFF",
          strokeWidth: 1,
          selectable: false,
          strokeDashArray: [2, 2]
        }))

        groupLineGrid.addWithUpdate(new fabric.Line([0, gridsize * x, this.canvas.width, gridsize * x], {
          stroke: "#DCEAEAFF",
          strokeWidth: 1,
          selectable: false,
          strokeDashArray: [2, 2]
        }))
      }
      this.canvas.add(groupLineGrid)
      // this.canvas.renderAll();
    },

  },
  computed:{
    ga(){
      let gg = this.canvas.getActiveObjects()
      return gg
    }
  },
  mounted() {
    this.canvas = new fabric.Canvas('canvas',
      {
        saveObjectStacking:false,
        width: this.canvasWidth,
        height: this.canvasHeight,
        selection: false
      });
    this.canvas.preserveObjectStacking = true;
    const bg = fabric.Image.fromURL('/map/background.png', function(img) {
      let oImg = img.set({
        left: 0,
        top: 0,
        angle: 0,
        width: 500,
        height:600,
      });

    })
    this.canvas.setBackgroundImage(bg)
    this.setCurrentMode('default')


  },
}
